import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return { ...state, actionProcessing: action.payload };

    case actionTypes.GET_ACTIVE_LIMITS:
      const limits = action.payload
      return { ...state, limits, actionProcessing: false };

    case actionTypes.POST_ACTIVE_LIMITS:
      const limits2 = action.payload
      return { ...state, limits: { ...state.limits, ...limits2 }, actionProcessing: false };

    default:
      return state;
  }
};
